import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Mode } from '../../../../../types';
import { ModeContext } from '../../../../../context';
import { checkoutCardExtraSelectors, checkinCardExtraSelectors } from '../model/selectors';
export function useCardExtraServices() {
    let cartExtraServicesByTypes;
    let availableCardExtraServices;
    const mode = useContext(ModeContext);
    if (mode === Mode.Checkin) {
        cartExtraServicesByTypes = useSelector(checkinCardExtraSelectors.getCardExtraServicesByTypes);
        availableCardExtraServices = useSelector(checkinCardExtraSelectors.getAvailableCardExtraServicesTypes);
    }
    else {
        cartExtraServicesByTypes = useSelector(checkoutCardExtraSelectors.getCardExtraServicesByTypes);
        availableCardExtraServices = useSelector(checkoutCardExtraSelectors.getAvailableCardExtraServicesTypes);
    }
    return { cartExtraServicesByTypes, availableCardExtraServices };
}
